<template>
	<div class="topic_dynamic">

		<div class="breadcrumb">动态管理
			<el-button type="primary" class="right_f" @click="cancel">返回</el-button>
			<el-button type="primary" class="right_f" @click="recommandSome(0)">批量取消</el-button>
			<el-button type="primary" class="right_f" @click="recommandSome(1)">批量精选</el-button>
		</div>

		<div class="search">
			<el-select v-model="classes" @change="changeClassesHandle">
				<el-option label="正常" value="2"></el-option>
				<el-option label="精选" value="5"></el-option>
				<el-option label="被举报" value="1"></el-option>
				<el-option label="已删除" value="4"></el-option>
			</el-select>

			<el-select v-model="status">
				<el-option v-if="classes != 5" label="用户ID" value='0'></el-option>
				<el-option label="动态ID" value='1'></el-option>
				<el-option v-if="classes != 5" label="动态关键字" value='2'></el-option>
			</el-select>

			<div class="el-input">
				<input type="text" :placeholder="placeholder" class="el-input__inner" v-model="keyWord"
					@keyup.enter="search"></input>
			</div>

			<el-select v-model="order">
				<el-option label="按发布时间排序" value="2"></el-option>
			</el-select>
		</div>

		<div class="search" style="margin-top:20px;">
			发布时间：
			<div class="el-input time">
				<el-date-picker v-model="beginAt" placeholder="请选择开始时间" class="qizhiDate"></el-date-picker>
			</div>
			-
			<div class="el-input time">
				<el-date-picker v-model="endAt" placeholder="请选择结束时间" class="qizhiDate"></el-date-picker>
			</div>

			<el-checkbox class="my-checkbox2" v-model="onlyShowGoodsDynamic">只显示带货动态</el-checkbox>
			<!-- <el-checkbox class="my-checkbox2" v-model="showSportDynamic">显示运动心情</el-checkbox> -->
			<el-button type="primary" @click="search">搜索</el-button>
		</div>

		<div class="dynamics">
			<el-table :data="dynamics" ref="multipleTable" style="overflow-x: auto;" @selection-change="changed">
				<el-table-column type="selection" width="55" fixed>
				</el-table-column>
				<el-table-column prop="index" label="序号" width="80" fixed>
				</el-table-column>
				<el-table-column prop="id" label="动态ID" width="100">
				</el-table-column>
				<el-table-column inline-template label="图片/视频" width="120">
					<div @click="showImg(row)">
						<img :src="row.revealImg" width='100%' style="padding-top: 8px" />
					</div>
				</el-table-column>
				<el-table-column inline-template label="图片数量/视频时长" width="100">
					<div>
						<span v-if="row.contentType == 1">{{row.videoTime}}</span>
						<span v-if="row.contentType == 0">{{row.imgNum}}</span>
					</div>
				</el-table-column>
				<el-table-column inline-template label="动态内容" width="200">
					<div>
						<div>{{row.content}}</div>
						<span v-if="row.linkTitle">{{row.linkTitle}}：</span>
						<span v-if="row.linkTitle" style="word-wrap:break-word">{{row.linkUrl}}</span>
					</div>
				</el-table-column>
				<el-table-column prop="topicTitle" label="关联话题标签" width="120"></el-table-column>
				<el-table-column inline-template label="发布时间" width="120">
					<div>
						<div>{{row.publishTime}}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="用户信息" width="150">
					<div>
						<div>{{row.uid}}</div>
						<div>{{row.name}}</div>
						<div>{{row.university}}</div>
					</div>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="100"></el-table-column>
				<el-table-column prop="readNum" label="阅读" width="100"></el-table-column>
				<el-table-column prop="likeCount" label="点赞" width="100"></el-table-column>
				<el-table-column prop="commentCount" label="评论" width="100"></el-table-column>
				<el-table-column prop="reportCount" label="举报" width="100"></el-table-column>
				<el-table-column inline-template label="操作信息" width="120">
					<div>
						<div>{{row.operator}}</div>
						<div>{{row.operateTime}}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="带货商品" width="100" fixed="right">
					<div>
						<span v-if="row.type == 0">无</span>
						<el-button v-if="row.type == 1" class="option" type="text" @click="checkGoodsDetail(row)">查看详情
						</el-button>
					</div>
				</el-table-column>
				<el-table-column inline-template label="操作" fixed="right">
					<span>
						<el-button class="option" type="text"
							v-if="row.status == '正常' || row.status == '被举报' && row.handpickStatus == 0"
							@click="recommand(row, 1)">精选</el-button>
						<el-button class="option" type="text" v-if="row.handpickStatus === 1"
							@click="recommand(row, 0)">取消精选</el-button>
						<el-button class="option" type="text" v-if="row.isDeleted === 0" @click="deleteDynamic(row, 1)">
							删除</el-button>
						<el-button class="option" type="text" v-if="row.isDeleted === 1" @click="deleteDynamic(row, 0)">
							取消删除</el-button>
					</span>
				</el-table-column>
			</el-table>
		</div>

		<div class="pagination">
			<el-pagination v-show="this.totalCount > 0" layout="prev, pager, next, jumper" :page-size="20"
				:current-page="currentPage" :total="totalCount" @current-change="handleCurrentChange">
			</el-pagination>
		</div>

		<!-- 图片预览弹框 -->
		<el-dialog title="图片预览" v-model="imgDialogVisible" :modal-append-to-body="false">
			<div style="text-align:center;min-height: 600px;">
				<p>{{title}}</p>
				<img :src="revealImg" class="img">
				<span class="preone" @click="showOtherImg(0)">上一张</span>
				<span class="next" @click="showOtherImg(1)">下一张</span>
			</div>
		</el-dialog>

		<el-dialog class="my-dialog" size="small" title="视频播放" v-model="videoDialogVisible" :modal-append-to-body="false">
			<div>
				<video :src="videoUrl" :poster="poster" autoplay="autoplay" controls="controls"></video>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="videoDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="videoDialogVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import { mapState, mapActions } from 'vuex'

	export default {
		data() {
			return {
				classes: '2',
				status: '1',
				topicId: this.$util.getUrlParam("topicId") * 1,
				keyWord: '',
				order: '2',
				beginAt: '',
				endAt: '',
				list: [],
				dynamics: [],
				totalCount: 0,
				currentPage: 1,
				onlyShowGoodsDynamic: false,
				showSportDynamic: false,
				imgDialogVisible: false,
				videoDialogVisible: false,
				revealImg: '',
				imgList: [],
				num: 0,
				title: '第 1 张',
				videoUrl: '',
				poster: '',
			}
		},
		watch: {
			videoDialogVisible() {
				let isShow = this.videoDialogVisible;
				if (!isShow) {
					document.getElementsByTagName('video')[0].pause()
				}
			}
		},
		mounted() {
			this.getList();
			let list = this.$util.getStore("goodsList");
			if (list && list != '{}') {
				this.$util.removeStore("goodsList");
			}
		},

		computed: {
			placeholder() {
				if (this.status === '0') {
					return '请输入用户ID'
				} else if (this.status === '1') {
					return '请输入动态ID'
				} else {
					return '请输入动态关键字'
				}
			},
			isDeleted() {
				if (this.classes === '0') {
					return -1
				} else if (this.classes === '4') {
					return 1
				} else {
					return 0
				}
			},
			isrecommand() {
				if (this.classes === '1' || this.classes === '2') {
					return 0
				} else if (this.classes === '5') {
					return 1
				} else {
					return -1
				}
			},
			reportStatus() {
				if (this.classes === '1') {
					return 2
				} else if (this.classes === '2') {
					return 1
				} else if (this.classes === '3') {
					return 9
				} else if (this.classes === '5') {
					return 10
				} else {
					return -1
				}
			}
		},
		methods: {
			// 弹框展示的方法
			showImg(row) {
				// 如果没有图片，则点击无预览弹框
				if (!row.files && row.files.length == 0) {
					return;
				}

				if (row.contentType == 1) {
					// 视频
					if (row.files[0].fileType == 3) {
						this.poster = row.files[1].url;
						this.videoUrl = row.files[0].url
					} else {
						this.poster = row.files[0].url;
						this.videoUrl = row.files[1].url
					}
					this.videoDialogVisible = true
				} else {
					this.revealImg = row.files[0].url;
					this.imgList = row.files;
					this.imgDialogVisible = true;

					// 重置图片预览 
					this.num = 0;
					this.title = '第 1 张';
				}
			},

			// 切换图片预览的方法
			showOtherImg(type) {
				let num = this.num;

				// 如果图片只有一张就不需要切换图片的操作
				if (this.imgList.length == 1) {
					return;
				}

				if (type == 1) {
					// 下一张
					num++;
				} else {
					// 上一张
					if (num == 0) {
						num = this.imgList.length - 1;
					} else {
						num--;
					}
				}
				num = num % this.imgList.length;
				this.num = num;
				this.title = '第 ' + (num + 1) + ' 张';
				this.revealImg = this.imgList[num].url;
				if (num == this.imgList.length - 1) {
					// 文案展示“最后一张”
					this.title = this.title + '（最后一张）'
				}
			},

			// 获取话题Id筛选列表
			getTopicIdList() {

				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v5/topic/list',
					body: JSON.stringify({
						fuzzyPhrase: '',
						pageNum: 1,
						pageSize: 20
					})
				}).then(response => {

				})
			},

			changeClassesHandle() {
				this.status = '1';
			},
			search() {
				let beginAt = this.beginAt ? new Date(this.beginAt.format("yyyy-MM-dd 00:00")).getTime() : '';
				let endAt = this.endAt ? new Date(this.endAt.format("yyyy-MM-dd 23:59")).getTime() : '';
				if (beginAt > endAt) {
					this.$util.errorMsg('搜索的开始时间不可以大于结束时间');
					return;
				}
				this.getList();
			},

			cancel() {
				let url = location.href;
				location.href = url.replace("dynamic", "topicManage");
			},

			getList() {
				//发起请求获取数据
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v4/operate/dynamic/list',
					body: JSON.stringify({
						topicId: this.topicId,
						isDeleted: this.isDeleted,
						reportStatus: this.reportStatus,
						onlyShowGoodsDynamic: this.onlyShowGoodsDynamic,
						keyType: this.status * 1,
						keyword: this.keyWord.trimLeft(),
						order: this.order * 1,
						beginAt: this.beginAt ? new Date(this.beginAt.format("yyyy-MM-dd 00:00")).getTime() : null,
						endAt: this.endAt ? new Date(this.endAt.format("yyyy-MM-dd 23:59:59")).getTime() : null,
						pageNum: this.currentPage,
						pageSize: 20
					})
				}).then(response => {

					if (response.data.error === 10000) {
						let data = response.data.data;
						if (data.totalCount) {
							this.list = data.list;
							this.totalCount = data.totalCount;
							this.getDynamics();
						} else {
							this.list = [];
							this.dynamics = [];
							this.totalCount = data.totalCount;
						}
					} else {
						this.$util.errorMsg(response.data.message);
					}
				})
			},

			// 查看商品详情
			checkGoodsDetail(row) {
				let goodsList = row.goodsList;
				this.$util.setStore('goodsList', goodsList);

				location.href = "#/yunying/dynamic/goodsDetail";
			},

			getDynamics() {
				this.dynamics = [];
				for (let i = 0; i < this.list.length; i++) {
					let preObj = this.list[i];
					let $index = (this.currentPage - 1) * 20 + i + 1,
						$files = preObj.files,
						$publishTime = new Date(preObj.publishTime).format('yyyy.MM.dd hh:mm'),
						$reportStatus = preObj.reportStatus,
						$contentType = preObj.contentType,  // 0: 普通内容1：视频内容
						$operator = preObj.lastOperater,
						$operateTime = (preObj.lastOperater) ? new Date(preObj.lastOperateTime).format('yyyy.MM.dd hh:mm') : "",
						$linkList = preObj.linkList,
						$linkTitle = '',
						$linkUrl = '',
						$isrecommand,
						$revealImg,
						$status,
						$imgNum = 0,
						$videoUrl,
						$videoTime = '';

					if (preObj.isDeleted === 1) {
						$status = '已删除';
						$isrecommand = -1;
					} else if ($reportStatus === 1 || $reportStatus === 9) {
						$status = '正常';
						$isrecommand = 0;
					} else if ($reportStatus === 2) {
						$status = '被举报';
						$isrecommand = 0;
					} else if ($reportStatus === 3) {
						$status = '忽略举报';
						$isrecommand = -1;
					}

					if (preObj.handpickStatus == 1 && this.classes != "1") {
						$status = '精选';
					}

					if ($files && $files.length) {
						$files.forEach(item => {
							if (item.fileType == 3) {
								$contentType = 1
							}
						})
					}
					// 是否视频
					if ($contentType == 1) { // 0: 普通内容1：视频内容
						$videoTime = new Date(preObj.size).format('mm:ss')
						if ($files && $files.length) {
							if ($files[0].fileType == 3) {
								$revealImg = $files[1].url;
								$videoUrl = $files[0].url
							} else {
								$revealImg = $files[0].url;
								$videoUrl = $files[1].url
							}
						}
					} else {
						if ($files && $files.length) {
							$revealImg = $files[0].url;
							$imgNum = $files.length;
						}
					}

					if ($linkList && $linkList.length > 0) {
						$linkTitle = $linkList[0].title;
						$linkUrl = $linkList[0].url;
					}

					this.dynamics.push({
						...preObj,
						readNum: preObj.readNum || 0,
						type: preObj.type || 0,
						linkTitle: $linkTitle,
						linkUrl: $linkUrl,
						index: $index,
						files: $files,
						revealImg: $revealImg,
						publishTime: $publishTime,
						status: $status,
						operator: $operator,
						operateTime: $operateTime,
						isrecommand: $isrecommand,
						imgNum: $imgNum,
						videoUrl: $videoUrl,
						videoTime: $videoTime
					})

				}
			},
			changed(selection) {
				this.selection = selection;
			},
			/***精选与取消精选**/
			recommand(row, status) {
				//发起请求
				this.recommandAjax({
					status,
					ids: [row.id],
					topicId: this.topicId
				})
			},
			/***批量精选与取消精选**/
			recommandSome(status) {
				let recommandList = [];
				if (!this.selection) {
					return;
				}
				if (status === 1) {
					this.selection.forEach((item) => {
						if (item.status == '正常' || item.status == '热门') {
							recommandList.push(item.id);
						}
					})
				} else if (status === 0) {
					this.selection.forEach((item) => {
						if (item.status == '精选') {
							recommandList.push(item.id);
						}
					})
				}
				if (!recommandList.length) {
					this.$util.errorMsg("您所选的动态均无法进行批量操作");
					return;
				}

				//发起请求
				this.recommandAjax({
					status,
					ids: recommandList,
					topicId: this.topicId
				})
			},
			//精选与取消精选请求
			recommandAjax(obj, url = '/adminapi/v2/operate/dynamic/status_change') {
				this.$http({
					method: 'POST',
					url: this.$util.domain + url,
					body: JSON.stringify(obj)
				}).then(response => {

					if (response.data.error === 10000) {
						this.getList();
					} else {
						this.$util.errorMsg('操作失败');
					}

				})
			},
			deleteDynamic(row, status) {

				let params = {
					id: row.id,
					isDeleted: status
				};
				this.recommandAjax(params, "/adminapi/v2/operate/dynamic/delete");
			},

			handleCurrentChange(val) {
				this.currentPage = val;

				this.getList();
			}
		}
	}
</script>
<style>
	.topic_dynamic .el-select {
		display: inline-block;
	}

	.topic_dynamic .el-input {
		display: inline-block;
  width: auto;
	}

	.topic_dynamic .el-button {
		display: inline-block;
	}

	.topic_dynamic .el-button+.el-button {
		margin-left: 0;
	}

	.search {
		margin-left: 30px;
	}

	.dynamics {
		margin-top: 20px;
		padding: 0 15px;
	}

	.time {
		width: 15%;
	}

	.my-checkbox {
		padding-left: 20px;
	}

	.my-checkbox2 {
		padding-left: 10px;
		padding-right: 20px;
	}

	.topic_dynamic .img {
		width: calc(100% - 140px);
	}

	.topic_dynamic .preone {
		position: absolute;
		top: 400px;
		left: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.topic_dynamic .next {
		position: absolute;
		top: 400px;
		right: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.topic_dynamic .my-dialog video {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// dynamic.vue?661e23ee